import { inject, injectable } from 'inversify-props';
import { IHttpClient, ILogger, ISettings } from '../common';
import { Stance, PagedResult } from '../../models';

export interface IStanceService {

	page(pageIndex: number, pageSize: number): Promise<PagedResult<Stance>>;
	list(): Promise<Stance[]>;
	get(id: number): Promise<Stance>;
	getMultiple(ids: number[]): Promise<Stance[]>;
	autocomplete(crtieria: string): Promise<Stance[]>;
	save(record: Stance): Promise<Stance>;
	delete(id: number): Promise<any>;
}

@injectable()
export class StanceService implements IStanceService {

	private cache: Promise<Stance[]>;

	constructor(
		@inject('IHttpClient') private httpClient: IHttpClient,
		@inject('ILogger') private logger: ILogger,
		@inject('ISettings') private settings: ISettings) {}

	public list(): Promise<Stance[]> {
		const url = `${this.settings.baseUrl}${this.settings.stanceBaseUrl}`;
		if (!this.cache) { this.cache = this.httpClient.get<Stance[]>(url); }
		return this.cache;
	}

	public page(pageIndex: number, pageSize: number): Promise<PagedResult<Stance>> {
		const url = `${this.settings.baseUrl}${this.settings.stanceBaseUrl}/${pageIndex}/${pageSize}`;
		return this.httpClient.get<PagedResult<Stance>>(url);
	}

	public get(id: number): Promise<Stance> {
		const url = `${this.settings.baseUrl}${this.settings.stanceBaseUrl}/${id}`;
		return this.httpClient.get<Stance>(url);
	}

	public getMultiple(ids: number[]): Promise<Stance[]> {
		const url = `${this.settings.baseUrl}${this.settings.stanceBaseUrl}/multiple/${ids.join(',')}`;
		return this.httpClient.get<Stance[]>(url);
	}

	public autocomplete(criteria: string): Promise<Stance[]> {
		const url = `${this.settings.baseUrl}${this.settings.stanceBaseUrl}/autocomplete/${criteria}`;
		return this.httpClient.get<Stance[]>(url);
	}

	public save(model: Stance): Promise<Stance> {
		this.cache = null; // INVALIDATE CACHE
		const payload = {
			name: model.name,
			id: model.id,
			description: model.description,
			sortBy: model.sortBy != null ? parseInt(model.sortBy.toString(), null) : 0,
		};
		let url = `${this.settings.baseUrl}${this.settings.stanceBaseUrl}`;
		if (model.id !== null && model.id !== undefined) {
			url += `/${model.id}`;
			return this.httpClient.put(url, payload);
		}
		return this.httpClient.post(url, payload);
	}

	public delete(id: number): Promise<any> {
		const url = `${this.settings.baseUrl}${this.settings.stanceBaseUrl}/${id}`;
		return this.httpClient.delete(url);
	}

}
